import React from 'react';
import './index.css';

import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import store from './store/createStore';

import App from './App';

const application = (
  <Provider store={store}>
    <App />
  </Provider>
);
const root = createRoot(document.getElementById('root'));
root.render(application);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
